<template>
	<sf-data-table
		ref="batchStatusTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="BatchStatusCols"
		:rows="rows"	
		:stripe="false"	
		@changedPage="changedPage"
	>		
	<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'sendBtn'">
				<span @click="() => sendAction(slotProps.row)">
					<sf-button>{{ getMessage_('MWPRS00060') }}</sf-button>
				</span>
				<!-- <sf-button  @click="() =>sendAction(slotProps.row)">
						{{ getMessage_('MWPRS00060') }}
				</sf-button> -->
			</template>
	</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/BatchStatus/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.batchStatusList;
		},
		BatchStatusCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('SWCC000206'), // 프로그램 ID
					prop: 'pgmId',
					minWidth: '200px',
					sortable: true						
				},				
				{
					label: this.getMessage_('QWCC001537'), // Job 그룹 ID
					prop: 'jobGroupId',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001536'), // Job Id
					prop: 'jobId',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001535'), // Job명
					prop: 'jobNm',
					minWidth: '200px',
					sortable: true					
				},
				{
					label: this.getMessage_('SWCC000891'), // 사용여부
					prop: 'useYn',
					minWidth: '100px',
					sortable: true					
				},
				{
					label: this.getMessage_('SWCC000172'), // 수정자
					prop: 'chgrId',
					minWidth: '140px',
					sortable: true
				},
				{
					label: this.getMessage_('SWCC000171'), // 수정일시
					prop: 'chgrDt',
					minWidth: '300px',
					sortable: true
				},
				{
					label: this.getMessage_('MTCO040036'), // 단건전송
					prop: 'sendBtn',
					minWidth: '300px',
					sortable: true,
					custom : true
				}					
			];
		}		
	},
	methods: {
		...serviceMethods,		
		resetTable() {
			this.$emit('Refresh');
		},		
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		sendAction(selectedRow){
			debugger;			
			//console.log(selectedRow);
			//값이 없을땐 이동을 못함.
			if (selectedRow.length < 1) {
				return false;
			}
			this.$sf_toggleLoading(true);
			this.sendBatchStart_(selectedRow)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.then(data => {
					debugger;
					if (data.code === 0) {
						this.$sf_toast({
							type: 'ok',
							title: 'Success',
							message: data.message
						});				
					}
					if (data.code === 1) {
						this.$sf_toast({							
							type: 'error',
							title: 'Error',
							message: data.message
						});
					}
					
				})				
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}		
	}
};
</script>

<style></style>
